module.exports = __webpack_public_path__ + "static/media/consultorio.769dae51.png";